import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import { FormInputChangedModel } from 'projects/workspace/src/app/shared/models';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { UIStatesEnum } from '../../../../models';
import { EcoOrderModel } from 'projects/workspace/src/app/e-commerce/modules/eco-orders/models';
import { ECommerceApiService } from 'projects/workspace/src/app/e-commerce/services';
import {
  selectEcoOrder,
  selectEcoOrderCurrentState
} from 'projects/workspace/src/app/e-commerce/modules/eco-orders/store/selectors';

@Component({
  selector: 'rnpl-eco-add-discount-modal',
  templateUrl: './eco-add-discount-modal.component.html',
  styleUrls: ['./eco-add-discount-modal.component.scss']
})
export class EcoAddDiscountModalComponent implements OnInit, OnDestroy {

  public ecoOrder: EcoOrderModel;
  public discountControl: FormControl = new FormControl({value: null});
  public discountAmountNetControl: FormControl = new FormControl({value: null});
  public discountAmountGrossControl: FormControl = new FormControl({value: null});

  readonly saveRequest$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly destroy$: Subject<void> = new Subject();

  constructor(
    private store: Store<AppState>,
    private readonly eCommerceApiService: ECommerceApiService,
    public dialogRef: MatDialogRef<EcoAddDiscountModalComponent>
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  ngOnInit(): void {
    this.trackChanges();

    this.store.select(selectEcoOrderCurrentState)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: UIStatesEnum) => {
        if (response === UIStatesEnum.VIEW) {
          this.discountControl.disable({emitEvent: false});
          this.discountAmountNetControl.disable({emitEvent: false});
          this.discountAmountGrossControl.disable({emitEvent: false});
        } else {
          this.discountControl.enable({emitEvent: false});
          this.discountAmountNetControl.enable({emitEvent: false});
          this.discountAmountGrossControl.enable({emitEvent: false});
        }
      });
  }

  private trackChanges(): void {
    this.store.select(selectEcoOrder)
      .pipe(takeUntil(this.destroy$))
      .subscribe((ecoOrder: EcoOrderModel) => {
        this.ecoOrder = ecoOrder;
        this.discountControl.patchValue(this.ecoOrder.discount);
        this.discountAmountNetControl.patchValue(this.ecoOrder.discountAmount);
        this.discountAmountGrossControl.patchValue(this.ecoOrder.discountAmountGross);
      });
  }

  public updateDiscount(field: FormInputChangedModel): void {
    this.saveRequest$.next(true);
    this.eCommerceApiService.updateEcoOrder(this.ecoOrder.id, field)
      .pipe(finalize(() => this.saveRequest$.next(false)))
      .subscribe(); // updated via store
  }

  public onDoneClick(): void {
    if (this.saveRequest$.getValue()) { return; }
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
